var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.BookingAudit"),
        width: "620px",
        "custom-class": "cargo-form-dialog",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.handleClose
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "cargo-form",
          attrs: { "label-width": "100px", "label-position": "left" }
        },
        [
          _vm.isDifferentJobOrBusinessFieldValues
            ? _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-warning",
                            staticStyle: {
                              color: "#e6a23c",
                              "margin-left": "5px"
                            }
                          }),
                          _c("span", { staticStyle: { "font-size": "12px" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Message.DifferentJobOrBusinessFieldValues"
                                )
                              )
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { "label-width": "0" }
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.radioType,
                            callback: function($$v) {
                              _vm.radioType = $$v
                            },
                            expression: "radioType"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.UseThisNo")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Customer") + "：" } },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.ColumnUtils.resolveColumnLabel(
                              _vm.TYPE_NAMES.basic_data_Company,
                              "cmpIdx",
                              _vm.job.customerId,
                              "chineseName"
                            )
                          )
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.OperationCompany")) + "："
                          )
                        ]
                      ),
                      _c("cargo-office-select", {
                        attrs: {
                          clearable: false,
                          "have-hq": false,
                          disabled: _vm.isTrustFrom,
                          "office-id": Number(_vm.job.opOffice),
                          "tag-name": "code",
                          tooltip: ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.opOffice = p.value
                            _vm.officeChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Operation") + "：" } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "op"
                          },
                          "default-value": _vm.job.op || "",
                          placeholder: _vm.differentForm.op
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("SeaExport.Operation")
                        },
                        on: {
                          change: function(p) {
                            _vm.job.op = p.value
                            _vm.differentForm.op = true
                            _vm.opChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          class: _vm.isBatchUpdate ? "" : "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.OperationDepartment")) +
                              "："
                          )
                        ]
                      ),
                      _c("cargo-department-select", {
                        attrs: {
                          "office-id":
                            Number(_vm.job.opOffice) ||
                            _vm.$store.getters.currentOfficeId,
                          "department-id": Number(_vm.job.opDepartment),
                          placeholder: _vm.differentForm.opDepartment
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("SeaExport.OperationDepartment")
                        },
                        on: {
                          change: function(p) {
                            _vm.job.opDepartment = p.value
                            _vm.differentForm.opDepartment = true
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.CustomerService") + "："
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "csr",
                        attrs: {
                          "method-params": {
                            officeId:
                              _vm.isTrustFrom || _vm.job.salesOffice === 1
                                ? _vm.job.opOffice
                                : _vm.job.salesOffice,
                            category: "role",
                            shape: "csr"
                          },
                          "default-value": _vm.job.csr || "",
                          placeholder: _vm.differentForm.csr
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("SeaExport.CustomerService")
                        },
                        on: {
                          change: function(p) {
                            _vm.job.csr = p.value
                            _vm.differentForm.csr = true
                            _vm.csrChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Documents") + "：" } },
                    [
                      _c("cargo-user-select", {
                        ref: "dc",
                        attrs: {
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "doc"
                          },
                          "default-value": _vm.job.dc || "",
                          placeholder: _vm.differentForm.dc
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("SeaExport.Documents")
                        },
                        on: {
                          change: function(p) {
                            _vm.job.dc = p.value
                            _vm.differentForm.dc = true
                            _vm.dcChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isAddUserDefinedRoles,
                          expression: "isAddUserDefinedRoles"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole1") + "："
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId1",
                        attrs: {
                          no: "24",
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "userDefinedRole1"
                          },
                          "default-value": _vm.job.userDefinedRoleId1 || "",
                          placeholder: _vm.differentForm.userDefinedRoleId1
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("CargoMsg.Cargo_userDefinedRole1")
                        },
                        on: {
                          change: function(p) {
                            _vm.job.userDefinedRoleId1 = p.value
                            _vm.differentForm.userDefinedRoleId1 = true
                            _vm.userDefinedRole1ChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isAddUserDefinedRoles,
                          expression: "isAddUserDefinedRoles"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole2") + "："
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId2",
                        attrs: {
                          no: "25",
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "userDefinedRole2"
                          },
                          "default-value": _vm.job.userDefinedRoleId2 || "",
                          placeholder: _vm.differentForm.userDefinedRoleId2
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("CargoMsg.Cargo_userDefinedRole2")
                        },
                        on: {
                          change: function(p) {
                            _vm.job.userDefinedRoleId2 = p.value
                            _vm.differentForm.userDefinedRoleId2 = true
                            _vm.userDefinedRole2ChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.departureStation") + "："
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.ColumnUtils.resolveColumnLabel(
                              _vm.TYPE_NAMES.basic_data_RailwayStation,
                              "code",
                              _vm.job.departureStation,
                              "englishName"
                            )
                          )
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.destinationStation") + "："
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.ColumnUtils.resolveColumnLabel(
                              _vm.TYPE_NAMES.basic_data_RailwayStation,
                              "code",
                              _vm.job.destinationStation,
                              "englishName"
                            )
                          )
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(_vm.$t("RailwayExport.vessel") + "："))
                      ]),
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: !_vm.isSameVesselAndFlight,
                          "select-type": _vm.TYPE_NAMES.static_data_Vessel,
                          cache: false,
                          filterable: "",
                          "allow-create": _vm.allowEditingVessel,
                          "default-value": _vm.isSameVesselAndFlight
                            ? _vm.job.vessel
                            : "",
                          "static-options": _vm.vesselList,
                          placeholder: _vm.differentForm.vessel
                            ? " "
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("RailwayExport.vessel")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.differentForm.vessel = true
                            _vm.onVesselSelectionChange
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("RailwayExport.voyageFlight") + "：")
                        )
                      ]),
                      _c("cargo-advance-select", {
                        ref: "voyageFlight",
                        attrs: {
                          disabled: !_vm.isSameVesselAndFlight,
                          cache: false,
                          filterable: "",
                          clearable: "",
                          "allow-create": _vm.allowEditingVoyageFlight,
                          "default-value": _vm.isSameVesselAndFlight
                            ? _vm.job.voyageFlight
                            : "",
                          "tag-name": "voyageNo",
                          "tag-value": "voyageNo",
                          "static-options": _vm.voyages,
                          placeholder: _vm.differentForm.voyageFlight
                            ? " "
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("RailwayExport.voyageFlight")
                        },
                        on: {
                          focus: _vm.txtVoyageFocusInHandler,
                          parentCallBack: function(p) {
                            _vm.job.voyageFlight = p.value
                            _vm.differentForm.voyageFlight = true
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Remarks") + "：" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", rows: 2 },
                        model: {
                          value: _vm.bookingAuditRemark,
                          callback: function($$v) {
                            _vm.bookingAuditRemark = $$v
                          },
                          expression: "bookingAuditRemark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { "margin-left": "100px" },
                      attrs: { no: "24" },
                      model: {
                        value: _vm.overwriteOriginalRemarkFlag,
                        callback: function($$v) {
                          _vm.overwriteOriginalRemarkFlag = $$v
                        },
                        expression: "overwriteOriginalRemarkFlag"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.OverwriteOriginalRemark"))
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        {
          staticStyle: { padding: "10px" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
          ),
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }